<template>
  <div class="dialog-wrapper">
    <el-dialog
        :visible="dialogData.visible"
        :width="dialogData.width"
        :before-close="dialogClose">
      <div slot="title" class="dialogTitle">{{dialogData.title}}</div>
      <div class="dialog-content"
           v-loading="dialogData.isLoading"
           :element-loading-text="dialogData.loading_text"
           element-loading-spinner="el-icon-loading">
        <div class="refundInfo">
          <el-form
              ref="refundRef"
              :label-position="labelPosition"
              label-width="180px"
              :model="form" :rules="refundRule"
          >
            <el-form-item label="退款公司 :">
              <span>{{switchInfo.nowCompany.name}}</span>
            </el-form-item>
            <el-form-item label="收款公司 ：" prop="company_name">
              <el-input v-model.trim="form.company_name"></el-input>
            </el-form-item>
            <el-form-item label="账户余额 :">
              <span>{{switchInfo.nowCompanyCanUse}}</span>
            </el-form-item>

            <el-form-item label="实际退款 (含服务费) ：" prop="taxMoney">
              <el-input
                  v-model="form.taxMoney"
                  suffix-icon="iconfont Bduan-iconqian"
              ></el-input>
            </el-form-item>
            <el-form-item label="当前计算费率：">{{this.$store.state.switchInfo.nowCompanyTax}}%</el-form-item>
            <el-form-item label="退款金额（不含服务费）:" prop="money">
              <el-input
                  v-model="form.money"
                  class="refund-input"
                  suffix-icon="iconfont Bduan-iconqian"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="收款银行账号 :" prop="bank_account_no">
              <el-input v-model="form.bank_account_no"></el-input>
            </el-form-item>
            <el-form-item label="收款支行名称 :" prop="bank_branch">
              <el-input v-model="form.bank_branch"></el-input>
            </el-form-item>
            <el-form-item label="联行号 :" prop="bank_line_no">
              <el-select v-model="form.bank_line_no" placeholder="选择联行号" @change="changeBankHandle" clearable filterable>
                <el-option v-for="item in allBankLineNo" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="填入手机验证码 :" prop="phonecode">
              <el-input v-model="form.phonecode">
                <template slot="append">
                  <div>
                    <!--                <el-button @click="getPhoneCode" class="get-register" :disabled="telIsDisable" :class="{'disabledClick': telIsDisable }">{{ codeText }}</el-button>-->
                    <el-button @click="getPhoneCode" class="get-register" :disabled="telIsDisable" :class="{'disabledClick': telIsDisable }">{{ codeText }}</el-button>
                  </div>
                </template>
              </el-input>
            </el-form-item>

            <div class="alertInfo">
<!--              <el-form-item prop="knowAlert">-->
                <el-checkbox
                    label="若您填写的收款信息错误，造成的后果由填写人承担"
                    name="type" v-model="knowAlert"
                    class="agree-radio"></el-checkbox>
<!--              </el-form-item>-->
            </div>

            <div class="faqi-refund-btn">
              <el-button type="primary" @click="verifyCode">发起退款</el-button>
            </div>
            <!-- <div class="errmsg">验证码错误，您还可以尝试{{codecount}}次</div> -->
          </el-form>
        </div>
      </div>
      <!--  弹框底部按钮  -->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button size="medium" type="primary" :disabled="dialogData.loading" @click="dialogConfirm" >{{ dialogData.confirmText }}</el-button>-->
<!--      </span>-->
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    dialogData: {
      type: Object,
      default() {
        return {}
      }
    },
    deliverData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      knowAlert: false,
      companyId: '',
      settlementId: '',
      noClick: false,
      selectedBankLine: {},
      userPhone: '',
      telIsDisable: false,
      codeText: '获取验证码',
      Verified: '',
      radio: '',
      allBankLineNo: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      labelPosition: "right",
      //   表达内容
      form: {
        company_name: "",
        money: "",
        taxMoney: "",
        bank_account_no: "",
        bank_branch: "",
        bank_line_no: "",
        phonecode: "",
        tax: "", //服务费
        knowAlert: true
      },
      code: "获取验证码",
      accountPhone: "",
      // 记录发送验证码的次数
      codeCount: 5,
      refundRule: {
        company_name: [{required: true, message: '收款公司名称不能为空'}],
        money: [
          { required: true, message: '退款金额不能为空'},
          // { validator: this.validateTransMoney}
        ],
        taxMoney: [{required: true, message: '实际退款金额不能为空'}],
        bank_account_no: [{required: true, message: '收款银行账号不能为空'}],
        bank_branch: [{required: true, message: '收款支行名称不能为空'}],
        bank_line_no: [{required: true, message: '联行号不能为空'}],
        phonecode: [{required: true, message: '验证码不能为空'}],
        // knowAlert: [{required: true, message: '请确认勾选相关告知'}],
      }
    };
  },
  methods: {
    dialogConfirm() {

    },
    initRefund() {
      console.log("this.$store.state.switchInfo", this.$store.state.switchInfo)
      this.companyId = this.switchInfo.companyId
      this.settlementId = this.switchInfo.settlementId
      this.dialogFormVisible = true
    },
    dialogClose() {
      this.dialogData.visible = false
      this.$refs.refundRef.resetFields()
      this.form.knowAlert = false
    },
    //  选择联行号时
    changeBankHandle(value) {
      this.selectedBankLine = this.allBankLineNo.find((item) => {
        return item.id === value
      })
      console.log(this.selectedBankLine)
    },
    validateTransMoney(rule, value, callback) {
      if (value > parseFloat(this.switchInfo.nowCompanyCanUse))
        callback("转账金额不能大于账户余额!")
    },
    onSuccess(val, location) {
      this.Verified = val
      if(val && location) {
        this.verificationCode()
      }
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.telIsDisable = false
        this.codeText = "获取验证码"
        return
      } else {
        this.telIsDisable = true
        this.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(()=> {
        this.countDown(time)
      }, 1000)
    },
    async getAllBankLine() {
      const getBankLinkNoList = await this.$api.getBankLinkNoList()
      this.allBankLineNo = getBankLinkNoList
    },
    // 获取验证码
    async getPhoneCode() {
      this.telIsDisable = true;
      let verCode = await this.$api.getCode({
        mobile: this.deliverData.userPhone,
      });
      if (!verCode) {
        this.$message.error("验证码发送失败")
      }
      await this.countDown(60)
    },
    async verifyCode() {
      this.noClick = true
      if (this.form.phonecode) {
        if (!this.knowAlert) {
          this.$message.error("请勾选告知信息")
        } else {
          const verifyResult = await this.$api.verifyPhone({
            mobile: this.deliverData.userPhone,
            code: this.form.phonecode
          })
          if (verifyResult) {
            // await this.refundHandle()
            await this.$refs.refundRef.validate(valid => {
              if (valid) {
                this.refundHandle()
              } else {
                this.$message.error("请填写必填信息")
                this.noClick = false
              }
            })
          } else {
            this.$message.error('验证码验证失败')
            this.noClick = false
          }
        }
      } else {
        this.$message.error("请先输入验证码")
      }
    },
    // 退款申请
    async refundHandle() {
      this.noClick = true
      const result = await this.$api.requestRefund({
        company_id: this.deliverData.switchInfo.nowCompany.id,
        company_name: this.form.company_name,
        bank_account_no: this.form.bank_account_no,
        bank_line_no: this.selectedBankLine.id,
        bank_branch: this.form.bank_branch,
        bank_name: this.selectedBankLine.name, // 总行名称
        money: this.form.taxMoney,// 含服务费的总金额
        tax: this.form.tax,
        channel_account: this.deliverData.switchInfo.settlementId,
      })
      if (result) {
        this.$message.success("发起退款成功")
        this.noClick = false
        this.dialogClose()
      }
    },
  },
  computed: {
    ...mapState(["switchInfo", "userInfo"]),
    watchMoney() {
      // return this.form.money
      return this.form.taxMoney
    }
  },
  watch: {
    watchMoney: {
      handler: function (newVal) {
        this.form.taxMoney = newVal
		
        if (newVal !== "") {
          if(this.deliverData.rateType==1){
                let res = this.mxServicePrice(
                this.form.taxMoney,
                this.deliverData.realTaxRate,
                this.deliverData.rateType
                ).price;
                this.form.money = (this.form.taxMoney - res).toFixed(2)
                this.form.tax = (this.form.taxMoney - this.form.money).toFixed(2)
          }else{
                this.form.money = this.mxServicePrice(
                this.form.taxMoney,
                this.deliverData.realTaxRate,
                this.deliverData.rateType
                ).resMoney;
                this.form.money = this.form.money.toFixed(2)
                this.form.tax = (this.form.taxMoney - this.form.money).toFixed(2)
          }
        } else {
          this.form.money = ''
        }

      },
      deep: true
    },
    telIsDisable: function (newVal) {
      this.telIsDisable = newVal
    },
    deliverData: {
      handler: function (newVal) {
        this.deliverData = newVal
        console.log("监听deliverData ",newVal)
      },
      deep: true
    }
  },
  mounted() {
    this.getAllBankLine()
  }
};
</script>
<style scoped lang="stylus">
.disabledClick {
  display: flex;
  background: gainsboro!important;
  border: none!important;
}
>>>.el-input-group__append {
  background: inherit;
  color: inherit;
}

//>>>.el-dialog__body{
//  padding: 10% 10%;
//}

.el-form-item__label {
  color: black !important;
  font-size: 16px !important;
}
.dialogTitle {
  position: relative;
  padding-left: 10px;
  font-size: 16px;
  color: black;
}
.dialogTitle:before {
  position: absolute;
  width: 4px;
  height: 20px;
  content: "";
  background: #1890ff;
  left: 0;
  top: 0;
}
.bankAlter
  display flex
  align-items center
  justify-content center
  flex-direction column
.alterBankForm
  margin 20px 0
.alterInfo
  margin 10px
>>>.el-dialog {
  border-radius: 10px;
}
.alertInfo {
  text-align center
}
.faqi-refund-btn
  margin 20px 0 0 0
  text-align center
</style>
